"use strict";
/* THIS IS A GENERATED FILE */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkubanaOrganizationsApiClient = void 0;
const BaseApiClient_1 = require("./BaseApiClient");
class SkubanaOrganizationsApiClient extends BaseApiClient_1.BaseApiClient {
    async getOrganizationByUser() {
        const path = `/v1.1/organizations`;
        return await this.request("get", path, undefined, undefined);
    }
    async putOrganization(organizationDto) {
        const path = `/v1.1/organizations`;
        return await this.request("put", path, undefined, organizationDto);
    }
    async deleteOrganizationPermissions(queryParams) {
        const path = `/v1.1/organizations/permissions`;
        return await this.request("delete", path, queryParams, undefined);
    }
    async putOrganizationPermissions(organizationPermissionsDto) {
        const path = `/v1.1/organizations/permissions`;
        return await this.request("put", path, undefined, organizationPermissionsDto);
    }
    async getAllOrganizationPermissionsByUser(userId) {
        const path = `/v1.1/organizations/permissions/${userId || ""}`;
        return await this.request("get", path, undefined, undefined);
    }
}
exports.SkubanaOrganizationsApiClient = SkubanaOrganizationsApiClient;
